var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.31836,
    y: 13,
    width: 15.9545,
    height: 8.27273,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.31836,
    y: 4.72656,
    width: 15.9545,
    height: 4.13636,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 4.33203H4.33333V6.4987H21.6667V4.33203ZM22.75 15.1654V12.9987L21.6667 7.58203H4.33333L3.25 12.9987V15.1654H4.33333V21.6654H15.1667V15.1654H19.5V21.6654H21.6667V15.1654H22.75ZM13 19.4987H6.5V15.1654H13V19.4987Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftStoreIcon);
export default __webpack_public_path__ + "static/media/leftStoreIcon.3f02e180dee151d2030624930881b7c2.svg";
export { ForwardRef as ReactComponent };